/**
 * Hero Mobile Background Module
 * Apply background image to ::before pseudo-element on mobile
 * 
 * @package JD_Theme
 */

export function initHeroMobile() {
  const heroSection = document.querySelector('.hero-section');
  
  if (!heroSection) return;
  
  const bgImage = heroSection.getAttribute('data-bg-image');
  
  if (bgImage && window.innerWidth <= 650) {
    // Create a style element to inject CSS for the ::before pseudo-element
    const style = document.createElement('style');
    style.textContent = `
      @media (max-width: 650px) {
        .hero-section::before {
          background-image: url('${bgImage}') !important;
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  // Update on resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth <= 650 && bgImage) {
        const existingStyle = document.querySelector('style[data-hero-mobile]');
        if (!existingStyle) {
          const style = document.createElement('style');
          style.setAttribute('data-hero-mobile', 'true');
          style.textContent = `
            @media (max-width: 650px) {
              .hero-section::before {
                background-image: url('${bgImage}') !important;
              }
            }
          `;
          document.head.appendChild(style);
        }
      }
    }, 150);
  });
}
